import { Button, CircularProgress, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { DualTitleDialog } from './DualTitleDialog';
import { useOpenMSpaceLock } from '../alerts.logic';
import { StyledButtonsWrapper } from '../StyledComponents';

interface IMSpaceLockDialogProps {
	entityId: string;
	open: boolean;
	isLocker: boolean;
	userFriendlyId: string;
	onClose: () => void;
}

export const MSpaceLockDialog = ({ open, entityId, isLocker, userFriendlyId, onClose }: IMSpaceLockDialogProps) => {
	const { t } = useTranslation();
	const [isWaiting, setIsWaiting] = useState(false);
	const { openMSpaceLock } = useOpenMSpaceLock(entityId, isLocker, () => {
		setIsWaiting(false);
		onClose();
	});
	const entityLabel = isLocker ? t('common.locker') : t('common.gate');

	const handleConfirm = async () => {
		setIsWaiting(true);
		await openMSpaceLock();
	};

	const handleClose = () => {
		if (!isWaiting) {
			onClose();
		}
	};

	return (
		<>
			<Dialog open={open && !isWaiting} onClose={handleClose}>
				<DualTitleDialog
					dialogTitle={t('common.open')}
					dialogTitleSecondary={`${entityLabel}: ${userFriendlyId}`}
				/>
				<DialogContent>
					<Typography variant='body1'>
						{isLocker
							? t('pages.alerts.openLockerMSpaceLockWarning')
							: `${t('pages.locations.openWarning')} ${t('pages.locations.gate')}?`}
					</Typography>
				</DialogContent>
				<DialogActions>
					<StyledButtonsWrapper>
						<Button variant='outlined' onClick={onClose}>
							{t('common.cancel')}
						</Button>
						<Button variant='contained' onClick={handleConfirm}>
							{t('common.open')}
						</Button>
					</StyledButtonsWrapper>
				</DialogActions>
			</Dialog>

			<Dialog open={open && isWaiting}>
				<DualTitleDialog
					dialogTitle={t(isLocker ? 'pages.alerts.mSpaceLockDialogTitle' : 'pages.alerts.mSpaceLockDialogTitleGate')}
					dialogTitleSecondary={`${entityLabel}: ${userFriendlyId}`}
				/>
				<DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 3 }}>
					<CircularProgress />
					<Typography variant='body1' textAlign='center'>
						{t(isLocker ? 'pages.alerts.mSpaceLockCommunicating' : 'pages.alerts.mSpaceLockCommunicatingGate')}
					</Typography>
					{isLocker && (
						<Typography variant='body2' textAlign='center' color='text.secondary'>
							{t('pages.alerts.openLockerMSpaceLockWarning')}
						</Typography>
					)}
				</DialogContent>
			</Dialog>
		</>
	);
};
